import React, { useState } from "react";
import './PaginationContainer.css'
import Pagination from "react-bootstrap/Pagination";
import { VscEmptyWindow } from "react-icons/vsc";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";

const PaginationContainer = ({ data, ItemComponent, itemsPerPage = 6 }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePageChange = (page) => setCurrentPage(page);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);

  return (
    <>
      {currentData.length === 0 ?
        <>
          <div className="text-secondary d-flex flex-column emty justify-content-center align-items-center">
            <VscEmptyWindow />
            <h3>Il n'y a pas données, ajouter !</h3>
          </div>
        </> :
        <>
          {currentData.map((item, index) => {
            return <ItemComponent key={index} item={item} />;
          })}
          {
            data.length >= itemsPerPage ?
              < div className="my-pagination" >
                <div className={`${currentPage === 1 ? "d-none" : ''} pagination-action`}>
                  <HiChevronDoubleLeft onClick={() => handlePageChange(1)} />
                </div>
                <div className={`${currentPage === 1 ? "d-none" : ''} pagination-action`}>
                  <HiChevronLeft
                    onClick={() => handlePageChange(currentPage - 1)}
                  // disabled={currentPage === 1}
                  />
                </div>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <div className={`${currentPage === page ? "active" : ''} pagination-action`}>
                    <span
                      className=""
                      key={page}
                      active={currentPage === page}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </span>
                  </div>
                ))}
                <div className={`${currentPage === totalPages ? "d-none" : ''} pagination-action`}>
                  <HiChevronRight
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  />
                </div>
                <div className={`${currentPage === totalPages ? "d-none" : ''} pagination-action`}>
                  <HiChevronDoubleRight onClick={() => handlePageChange(totalPages)} />
                </div>
              </div> : null
          }
        </>
      }
    </>
  );
};

export default PaginationContainer;
